import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css"
import "./styles/typography.css";
import App from "./app";
import { Provider } from "react-redux";
import { store } from './store/store'
import { HelmetProvider } from "react-helmet-async";

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
    <Provider store={store}>
        <App />
    </Provider>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
